import AncillaryUIModel from './ancillary';

class AncillaryCollectionUIModel {
  constructor(ancillaries = []) {
    this._ancillaries = [];

    this._ancillaries = ancillaries._collection.map(ancillary => {
      return new AncillaryUIModel(ancillary);
    });
  }

  getAllAncillaries() {
    return this._ancillaries;
  }

  getAncillaryByType(type) {
    const ancillaryIndex = this._ancillaries.findIndex(ancillary => {
      return ancillary.type === type;
    });

    return ancillaryIndex > -1 ? this._ancillaries[ancillaryIndex] : null;
  }
}

export default AncillaryCollectionUIModel;
